module.exports = __webpack_public_path__ + "static/customer-run-ace22346b1e555b09e3797fc030314fa.jpg";